exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ContentHtml[data-v-4c475334]{\n    max-width:900px;\n    overflow:scroll;\n}\n", ""]);

// exports
